import axios from "axios";
import AuthService from "../login/auth.service";
import { personas } from "../../components/generico/utils/UrlAPI";


var _idPersona =
  AuthService.getSocio()=== undefined
    ? "-"
    : AuthService.getSocio().idPersona.trim();

class DatosPersonalesService {
  
  async listadoDBC(_tipo, _codigoFiltrado) {
    /*var data = JSON.stringify({
      clave: "",
      dato: AuthService.getSocio().numeroSocio.trim(),
      tipo: "K",
      tipoListado: _tipo,
      codigoFiltro: _codigoFiltrado,
    });*/

    var urlListado = "";
    if(_tipo === "D"){
      urlListado = "ubicaciones/departamentos";
    } else {
      if(_tipo === 'C'){
        urlListado = "ubicaciones/ciudades/" + _codigoFiltrado;
      } else {
        urlListado = "ubicaciones/barrios/" + _codigoFiltrado;
      }
    }

    var config = {
      /*method: "post",
      url: "listado_dcb/?access_token=" + AuthService.getCurrentToken(),
      headers: {
        "Content-Type": "application/json",
      },
      data: data,*/
      method: "get",
      url: personas + urlListado,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken()
      }
    };

    return await axios(config);
  }

  async actualizarDatos(
    _correo,
    _telefonoParticular,
    _celular,
    _direccionParticular,
    _departamento,
    _ciudad,
    _barrio,
    _entidadLaboral,
    _cargo,
    _puestoPublico,
    _presentadoPEPS,
    _latitud,
    _longitud
  ) {
    var data = JSON.stringify({
      idPersona: _idPersona,
      correoElectronico: _correo.toLowerCase(),
      telefonoParticular: _telefonoParticular,
      celular: _celular,
      direccionParticular: _direccionParticular.toUpperCase(),
      departamento: _departamento,
      ciudad: _ciudad,
      barrio: _barrio,
      usuario: "",
      fechaModificacion: new Date(),
      entidadLaboral: _entidadLaboral.toUpperCase(),
      cargo: _cargo.toUpperCase(),
      mostrar: "N",
      puestoPublico: _puestoPublico,
      presentadoPEPS: _presentadoPEPS,
      canal: "WEB",
      latitud: _latitud,
      longitud:_longitud
    });

    console.log("body: ", data);

    var config = {
      /*method: "post",
      url: "actualizacion_datos/?access_token=" + AuthService.getCurrentToken(),
      headers: {
        "Content-Type": "application/json",
      },
      data: data,*/
      method: "put",
      url: personas + "datos",
      headers: {
        "Content-Type":"application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken()
      },
      data:data,
    };

    return await axios(config);
  }
}
export default new DatosPersonalesService();
